import { createContext, useContext, useEffect, useState } from "react";
import { api, ensureDownloadToken, clearDownloadToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("cph_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(async (res) => {
        await ensureDownloadToken().catch(() => {});
        setUser(res.data);
      })
      .catch(() => {
        localStorage.removeItem("cph_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  // Keep the short-lived download token fresh while a session is active
  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => ensureDownloadToken().catch(() => {}), 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password, turnstileToken) => {
    const { data } = await api.post("/auth/login", { email, password, turnstile_token: turnstileToken });
    localStorage.setItem("cph_token", data.access_token);
    await ensureDownloadToken().catch(() => {});
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("cph_token");
    clearDownloadToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
